import React from 'react'
import * as PropTypes from 'prop-types'
import { Label } from './label'
import isValidEmail from 'utils/is-valid-email'

export const Email = ({ id, label, name, placeholder, register, required, ...props }) => {
  return (
    <React.Fragment>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      <input
        type='email'
        ref={register({
          required,
          validate: value => (required || value ? isValidEmail(value) : true),
        })}
        name={name}
        placeholder={placeholder}
        required={required}
        id={id}
        {...props}
      />
    </React.Fragment>
  )
}

Email.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  register: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
}

Email.defaultProps = {
  id: 'email',
  label: 'Email',
  name: 'Email',
  placeholder: null,
  required: false,
}
